import { FC } from 'react';

import { RequirePermission } from '@gasbi/shared/common/providers/PermissionProvider';

import { Theme, useTheme } from '@mui/joy';

import { UserPermissionType } from '@components/Permissions/types';
import {
  Button,
  ButtonWithSkeletonProps,
} from '@components/ui/skeletons/ButtonWithSkeleton';

import HistoryIcon from '@assets/history.svg?react';

type HistoryButtonProps = ButtonWithSkeletonProps & {
  permission: UserPermissionType;
};

export const getHistoryButtonStyle = (theme: Theme) => {
  const dark = theme.palette.isDarkMode;

  return {
    background: dark ? theme.palette.primary[900] : theme.palette.primary[50],
    color: dark ? theme.palette.primary[300] : theme.palette.primary[500],
    '&:hover': {
      background: dark
        ? theme.palette.primary[800]
        : theme.palette.primary[100],
    },
  };
};

const HistoryButton: FC<HistoryButtonProps> = ({
  skeleton,
  children = 'Історія переміщень',
  onClick,
  permission,
  ...props
}) => {
  const theme = useTheme();

  return (
    <RequirePermission name={permission}>
      <Button
        startDecorator={<HistoryIcon />}
        size='sm'
        skeleton={skeleton}
        sx={{
          ...props.sx,
          ...getHistoryButtonStyle(theme),
        }}
        onClick={onClick}
      >
        {children}
      </Button>
    </RequirePermission>
  );
};

export default HistoryButton;
